import {
  FEATURE_FLAGS,
  usePostHydrationFeatureFlagValue,
} from "@/feature-flags"

/**
 * Whether the viewer gets the loop-grouped sidebar.
 *
 * Its own flag rather than `COVAL_ONLY`: PostHog targets it at Coval accounts
 * while the grouping settles, and a nav shape has to be able to widen past
 * Coval without dragging every other internal-only surface along with it.
 *
 * Read post-hydration because this gate picks a whole nav tree, not a detail
 * inside one. PostHog can hand the first client render a cached value the
 * server never had, and the two navs disagree on which rows exist and which
 * command shortcuts are registered — so trusting that value would hydrate the
 * grouped sidebar over the server's flat one. Waiting costs a frame of the
 * shipped nav; not waiting costs a rebuilt sidebar in front of the user.
 */
export function useImprovementLoopNav(): boolean {
  return (
    usePostHydrationFeatureFlagValue(FEATURE_FLAGS.IMPROVEMENT_LOOP_NAV) ===
    true
  )
}
